module.exports = ".footer {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: #f8f8f8;\n  color: #08486c;\n  text-align: center; }\n\n@media only screen and (max-width: 767px) {\n  .footer {\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    background-color: #f8f8f8;\n    color: #08486c;\n    text-align: center !important;\n    font-size: 10px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.scss
// module id = ./src/app/footer/footer.component.scss
// module chunks = main